import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import {
  widgetReady,
  warnTooSmall,
  userAdded
} from './redux/actions/embedding';
import store from './redux/store';
import { loadProblemLog } from './utils/utils';
import { APP_CFG } from './appcfg';
import App from './App';
import {
  setProblemLogIds,
  setStage,
  setTestPageType,
  TestPageType
} from './redux/actions/ui';
import { getScreenSize, ProblemStage, ScreenSize } from 'its-pages';
import { ColorModeSelector } from '@lib/theme/theme-switch';

const root = createRoot(document.getElementById('root') as HTMLElement);

async function getConfig(): Promise<any> {
  if (APP_CFG.testApp) {
    const searchParams = new URLSearchParams(window.location.search);
    const problemLogId = searchParams.get('problemLogId');
    const problemLogIds = problemLogId
      ? [problemLogId]
      : searchParams.get('problemLogIds')?.split(',');

    if (problemLogIds) {
      setTimeout(() => {
        loadProblemLog(store.dispatch, problemLogIds[0]);
        store.dispatch(setProblemLogIds(problemLogIds));
        store.dispatch(setStage(ProblemStage.ShowResult));
        store.dispatch(setTestPageType(TestPageType.Results));
      }, 1000);
    } else {
      APP_CFG.switchModule('Assessing Suicide Risk');
    }
    store.dispatch(userAdded({ userId: 'test user' }));
  }

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ColorModeSelector force={!APP_CFG.testApp ? 'light' : undefined }>
          <App />
        </ColorModeSelector>
      </Provider>
    </React.StrictMode>,
  );

  store.dispatch(widgetReady());
}

getConfig();

if (getScreenSize() <= ScreenSize.xs) {
  store.dispatch(warnTooSmall(true));
}
